export interface ComicChapter {
  id: string;
  title: string;
  updateDate: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  tags: string[];
  rating: number;
  description: string;
  longDescription: string;
  chapters: ComicChapter[];
  updateDate: string;
  views: number;
  status: '连载中' | '已完结';
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { name: '全部', slug: 'all', icon: 'ri-apps-line' },
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line' },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line' },
  { name: '动作', slug: 'action', icon: 'ri-flashlight-line' },
  { name: '悬疑', slug: 'mystery', icon: 'ri-search-eye-line' },
  { name: '喜剧', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { name: '惊悚', slug: 'thriller', icon: 'ri-ghost-line' },
  { name: '日常', slug: 'slice-of-life', icon: 'ri-sun-line' },
  { name: '古风', slug: 'historical', icon: 'ri-ancient-gate-line' },
];

export const comics: Comic[] = [
  {
    id: '1',
    title: '暗夜王爵',
    author: '金贤秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20dark%20fantasy%20illustration%20of%20a%20mysterious%20nobleman%20with%20red%20eyes%20in%20black%20suit%2C%20Gothic%20atmosphere%2C%20dramatic%20lighting%2C%20clean%20composition%2C%20simple%20dark%20background%2C%20soft%20shadows&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['吸血鬼', '贵族', '暗黑'],
    rating: 9.5,
    description: '在黑暗的贵族世界中，一位拥有神秘力量的王爵展开了一场关于权力与爱情的史诗旅程。',
    longDescription: '在一个被月光笼罩的古老城堡中，暗夜王爵洛维斯统治着吸血鬼贵族社会。他拥有无与伦比的力量，却始终无法摆脱对已故恋人的思念。当一位来自现代世界的少女意外闯入他的领地，古老的诅咒开始松动，一场跨越生死的爱情故事就此展开。权力、阴谋、背叛与救赎，在这部作品中被完美交织。',
    chapters: [
      { id: 'ch1', title: '第1话 暗夜的访客', updateDate: '2026-08-04' },
      { id: 'ch2', title: '第2话 月光下的誓言', updateDate: '2026-08-03' },
      { id: 'ch3', title: '第3话 血色蔷薇', updateDate: '2026-08-02' },
      { id: 'ch4', title: '第4话 命运的齿轮', updateDate: '2026-08-01' },
      { id: 'ch5', title: '第5话 深渊之眼', updateDate: '2026-07-31' },
      { id: 'ch6', title: '第6话 禁忌之门', updateDate: '2026-07-30' },
    ],
    updateDate: '2026-08-04',
    views: 125800,
    status: '连载中',
    isHot: true,
    isNew: false,
  },
  {
    id: '2',
    title: '甜蜜陷阱',
    author: '李智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20romantic%20illustration%20of%20a%20beautiful%20woman%20and%20handsome%20man%20in%20cafe%2C%20soft%20pastel%20pink%20tones%2C%20sweet%20dating%20scene%2C%20simple%20cafe%20background%2C%20clean%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['职场', '甜宠', '契约'],
    rating: 9.3,
    description: '为了偿还债务而签订假婚约的她，却意外陷入了总裁的甜蜜陷阱之中。',
    longDescription: '林晓月是一个普通的咖啡店店员，因为父亲的医疗费欠下了巨额债务。正当她走投无路时，冷面总裁韩逸辰提出了一个无法拒绝的提议——假结婚。她以为只是一场交易，却不知道对方早已布下天罗地网般的甜蜜陷阱。当契约结束的日子一天天临近，两颗心是否还能回到原点？',
    chapters: [
      { id: 'ch1', title: '第1话 意外相遇', updateDate: '2026-08-03' },
      { id: 'ch2', title: '第2话 契约婚姻', updateDate: '2026-08-02' },
      { id: 'ch3', title: '第3话 同居生活', updateDate: '2026-08-01' },
      { id: 'ch4', title: '第4话 心动信号', updateDate: '2026-07-31' },
      { id: 'ch5', title: '第5话 情敌登场', updateDate: '2026-07-30' },
    ],
    updateDate: '2026-08-03',
    views: 98300,
    status: '连载中',
    isHot: true,
    isNew: false,
  },
  {
    id: '3',
    title: '剑道至尊',
    author: '朴正泰',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20action%20martial%20arts%20illustration%20of%20a%20young%20swordsman%20with%20flowing%20hair%20holding%20a%20glowing%20sword%2C%20dynamic%20pose%2C%20energy%20effects%2C%20simple%20mountain%20background%2C%20clean%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    tags: ['武侠', '修炼', '热血'],
    rating: 9.4,
    description: '从废材少年到剑道至尊，他用手中长剑劈开了一条通往巅峰的血路。',
    longDescription: '在一个以武为尊的世界里，林天原本是剑道世家最不被看好的庶子。因为无法凝聚剑气，他被家族驱逐，受尽欺凌。然而在一次意外中，他获得了远古剑圣的传承，从此命运被彻底改写。从最低谷一步步攀登，每一次挥剑都是对过去的告别，每一次战斗都是对未来的宣言。',
    chapters: [
      { id: 'ch1', title: '第1话 废材少年', updateDate: '2026-08-04' },
      { id: 'ch2', title: '第2话 剑圣传承', updateDate: '2026-08-03' },
      { id: 'ch3', title: '第3话 初试锋芒', updateDate: '2026-08-02' },
      { id: 'ch4', title: '第4话 家族试炼', updateDate: '2026-08-01' },
      { id: 'ch5', title: '第5话 一鸣惊人', updateDate: '2026-07-31' },
      { id: 'ch6', title: '第6话 剑指苍穹', updateDate: '2026-07-30' },
      { id: 'ch7', title: '第7话 巅峰对决', updateDate: '2026-07-29' },
    ],
    updateDate: '2026-08-04',
    views: 156200,
    status: '连载中',
    isHot: true,
    isNew: false,
  },
  {
    id: '4',
    title: '第七区谜案',
    author: '崔敏浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20style%20detective%20illustration%2C%20a%20detective%20in%20trench%20coat%20standing%20in%20rainy%20alley%20at%20night%2C%20noir%20atmosphere%2C%20mysterious%20mood%2C%20simple%20dark%20background%2C%20clean%20composition&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: '悬疑',
    categorySlug: 'mystery',
    tags: ['侦探', '犯罪', '反转'],
    rating: 9.6,
    description: '连续发生的离奇命案背后，隐藏着一个与第七区有关的惊天秘密。',
    longDescription: '首尔第七区连续发生了三起手法相同的离奇命案，每一起案件现场都留下了一个神秘的符号。警探姜宇轩接手此案后，发现所有线索都指向一个已经解散了二十年的神秘组织。当他越接近真相，身边的人却一个接一个地遭遇不测。信任与背叛、正义与邪恶的边界在这部悬疑巨作中被一次次模糊。',
    chapters: [
      { id: 'ch1', title: '第1话 第一具尸体', updateDate: '2026-08-02' },
      { id: 'ch2', title: '第2话 神秘符号', updateDate: '2026-08-01' },
      { id: 'ch3', title: '第3话 旧案重提', updateDate: '2026-07-31' },
      { id: 'ch4', title: '第4话 目击证人', updateDate: '2026-07-30' },
    ],
    updateDate: '2026-08-02',
    views: 87200,
    status: '连载中',
    isHot: false,
    isNew: true,
  },
  {
    id: '5',
    title: '魔女食堂',
    author: '尹素英',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20fantasy%20illustration%20of%20a%20beautiful%20witch%20chef%20in%20magical%20kitchen%20with%20floating%20ingredients%2C%20warm%20cozy%20atmosphere%2C%20candlelit%20scene%2C%20simple%20background%2C%20clean%20composition&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['美食', '治愈', '魔法'],
    rating: 9.2,
    description: '只在深夜营业的神秘食堂里，魔女为心怀遗憾的客人烹制能实现愿望的料理。',
    longDescription: '在城市最不起眼的角落，有一家只在深夜零点开门的"魔女食堂"。店主是一位神秘的魔女，她用魔法烹制的美食能够治愈人心最深处的创伤。每一位走进食堂的客人都有自己的故事——失恋的上班族、迷茫的学生、思念亲人的老人...在品尝料理的过程中，他们发现愿望的实现方式，往往出乎意料。',
    chapters: [
      { id: 'ch1', title: '第1话 深夜食堂', updateDate: '2026-08-03' },
      { id: 'ch2', title: '第2话 第一位客人', updateDate: '2026-08-02' },
      { id: 'ch3', title: '第3话 记忆的味道', updateDate: '2026-08-01' },
      { id: 'ch4', title: '第4话 魔女的过去', updateDate: '2026-07-31' },
      { id: 'ch5', title: '第5话 月光料理', updateDate: '2026-07-30' },
    ],
    updateDate: '2026-08-03',
    views: 76400,
    status: '连载中',
    isHot: false,
    isNew: true,
  },
  {
    id: '6',
    title: '社内恋爱禁止',
    author: '郑多彬',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20style%20office%20couple%20illustration%2C%20two%20colleagues%20secretly%20holding%20hands%20behind%20desk%2C%20playful%20mood%2C%20warm%20sunlight%20through%20window%2C%20simple%20office%20background%2C%20clean%20composition&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: '喜剧',
    categorySlug: 'comedy',
    tags: ['职场', '恋爱', '搞笑'],
    rating: 9.1,
    description: '公司明令禁止办公室恋情，但这对欢喜冤家偏偏擦出了爱的火花。',
    longDescription: '在一家严格执行"禁止社内恋爱"规定的广告公司里，市场部的王牌策划金智昊和设计部的天才设计师韩素熙，从入职第一天起就是水火不容的死对头。然而在一次加班后的意外事件中，两人发现了对方不为人知的一面，敌对关系悄然发生了微妙的变化。在公司明令禁止恋爱的铁规下，这段偷偷摸摸的办公室恋情笑料百出。',
    chapters: [
      { id: 'ch1', title: '第1话 冤家路窄', updateDate: '2026-08-04' },
      { id: 'ch2', title: '第2话 加班夜', updateDate: '2026-08-03' },
      { id: 'ch3', title: '第3话 地下恋情', updateDate: '2026-08-02' },
      { id: 'ch4', title: '第4话 危机四伏', updateDate: '2026-08-01' },
    ],
    updateDate: '2026-08-04',
    views: 89200,
    status: '连载中',
    isHot: false,
    isNew: true,
  },
  {
    id: '7',
    title: '九尾狐传',
    author: '宋智雅',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20style%20nine-tailed%20fox%20spirit%20woman%20in%20traditional%20hanbok%2C%20mystical%20atmosphere%2C%20cherry%20blossom%20petals%2C%20ancient%20Korean%20palace%20background%2C%20ethereal%20lighting%2C%20clean%20composition&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: '古风',
    categorySlug: 'historical',
    tags: ['神话', '古装', '爱情'],
    rating: 9.7,
    description: '修行千年的九尾狐为了寻找转世的爱人，在现代都市展开了一段跨越时空的恋歌。',
    longDescription: '白雅琳是一只修行了九百九十九年的九尾狐，只差一年就能修炼成仙。然而在最后关头，她选择放弃仙道，来到凡间寻找千年前为她牺牲的爱人转世。在现代首尔的繁华街头，她以一名插画师的身份生活，直到遇见了那个与前世恋人长得一模一样的男人。但命运似乎总爱与这对恋人开玩笑，千年前的悲剧是否还会重演？',
    chapters: [
      { id: 'ch1', title: '第1话 千年修行', updateDate: '2026-08-03' },
      { id: 'ch2', title: '第2话 凡间之行', updateDate: '2026-08-02' },
      { id: 'ch3', title: '第3话 转世之人', updateDate: '2026-08-01' },
      { id: 'ch4', title: '第4话 前世之约', updateDate: '2026-07-31' },
      { id: 'ch5', title: '第5话 危机逼近', updateDate: '2026-07-30' },
      { id: 'ch6', title: '第6话 千年之恋', updateDate: '2026-07-29' },
    ],
    updateDate: '2026-08-03',
    views: 189500,
    status: '连载中',
    isHot: true,
    isNew: false,
  },
  {
    id: '8',
    title: '末日生存法则',
    author: '韩正宇',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20post-apocalyptic%20manhwa%20style%20survival%20illustration%2C%20lone%20survivor%20with%20backpack%20in%20ruined%20cityscape%2C%20dramatic%20sky%2C%20ruins%20background%2C%20intense%20atmosphere%2C%20clean%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: '惊悚',
    categorySlug: 'thriller',
    tags: ['末日', '生存', '人性'],
    rating: 9.4,
    description: '突如其来的灾难让世界陷入混乱，普通上班族在末日中挣扎求生的故事就此展开。',
    longDescription: '当陨石雨毫无征兆地袭击地球时，平凡的上班族金哲民正在地铁上通勤。灾难过后，世界秩序崩塌，资源匮乏，幸存者们为了活下去不惜一切代价。在这个道德沦丧的末日世界里，金哲民必须做出选择：是坚守人性的底线，还是为了生存不择手段？每一步抉择都在考验着他的灵魂。',
    chapters: [
      { id: 'ch1', title: '第1话 陨石坠落', updateDate: '2026-08-01' },
      { id: 'ch2', title: '第2话 地铁惊魂', updateDate: '2026-07-31' },
      { id: 'ch3', title: '第3话 第一夜', updateDate: '2026-07-30' },
      { id: 'ch4', title: '第4话 幸存者营地', updateDate: '2026-07-29' },
    ],
    updateDate: '2026-08-01',
    views: 112400,
    status: '连载中',
    isHot: false,
    isNew: false,
  },
  {
    id: '9',
    title: '花店日记',
    author: '朴素妍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20slice%20of%20life%20manhwa%20style%20florist%20girl%20in%20cozy%20flower%20shop%2C%20warm%20sunlight%2C%20colorful%20blooms%2C%20peaceful%20atmosphere%2C%20simple%20shop%20background%2C%20clean%20composition&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: '日常',
    categorySlug: 'slice-of-life',
    tags: ['治愈', '慢生活', '花艺'],
    rating: 9.0,
    description: '在首尔一条安静的小巷里，花店店主与客人们之间温暖治愈的日常故事。',
    longDescription: '厌倦了996职场生活的韩素拉，辞去了光鲜亮丽的大公司工作，在首尔一条安静的小巷里开了一家小小的花店。每天与鲜花为伴，为不同的客人制作花束，聆听他们背后的故事。有表白成功的少年、求婚的年轻人、庆祝金婚的老夫妻...每一束花都承载着独一无二的情感，每一个故事都温暖着彼此的心。',
    chapters: [
      { id: 'ch1', title: '第1话 辞职那天', updateDate: '2026-08-04' },
      { id: 'ch2', title: '第2话 第一位客人', updateDate: '2026-08-03' },
      { id: 'ch3', title: '第3话 向日葵的秘密', updateDate: '2026-08-02' },
      { id: 'ch4', title: '第4话 雨中花语', updateDate: '2026-08-01' },
      { id: 'ch5', title: '第5话 四季花事', updateDate: '2026-07-31' },
    ],
    updateDate: '2026-08-04',
    views: 65800,
    status: '连载中',
    isHot: false,
    isNew: false,
  },
  {
    id: '10',
    title: '夜色追踪',
    author: '姜栋元',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20action%20noir%20manhwa%20style%20illustration%20of%20a%20man%20in%20black%20coat%20running%20through%20neon-lit%20Seoul%20street%20at%20night%2C%20dynamic%20motion%2C%20cyberpunk%20vibe%2C%20clean%20composition&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    tags: ['犯罪', '悬疑', '复仇'],
    rating: 9.3,
    description: '一位前特种兵为寻找失踪的妹妹，潜入首尔地下犯罪世界的惊险故事。',
    longDescription: '前特种部队成员张泰浩退伍后，唯一的精神支柱就是相依为命的妹妹张秀敏。当妹妹在首尔无端失踪后，他凭借军人的直觉和技能，一步步深入首尔最黑暗的地下世界。黑帮、走私、人口贩卖...每一个线索都引向更大的阴谋。为了找到妹妹，他愿意碾碎一切阻挡在前面的障碍。',
    chapters: [
      { id: 'ch1', title: '第1话 失联', updateDate: '2026-08-03' },
      { id: 'ch2', title: '第2话 地下拳场', updateDate: '2026-08-02' },
      { id: 'ch3', title: '第3话 线人', updateDate: '2026-08-01' },
      { id: 'ch4', title: '第4话 红色集装箱', updateDate: '2026-07-31' },
    ],
    updateDate: '2026-08-03',
    views: 104600,
    status: '连载中',
    isHot: false,
    isNew: false,
  },
  {
    id: '11',
    title: '缘分天注定',
    author: '安孝珍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20style%20couple%20under%20cherry%20blossom%20tree%20in%20spring%2C%20soft%20pink%20and%20white%20color%20palette%2C%20dreamy%20atmosphere%2C%20university%20campus%20background%2C%20clean%20composition&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['校园', '初恋', '纯爱'],
    rating: 9.2,
    description: '大学校园里，两个来自完全不同世界的人，因为一封寄错的信而走到了一起。',
    longDescription: '大学二年级的春天，理工女林书妍意外收到了寄给隔壁班同名同姓男生的情书。这个美丽的误会让她认识了音乐系的才子李在勋。一个是整天泡在实验室的学霸，一个是沉浸在音乐世界的浪漫主义者，两个看似毫无交集的人，在一次次偶然的相遇中，慢慢走近了彼此的世界。',
    chapters: [
      { id: 'ch1', title: '第1话 寄错的信', updateDate: '2026-08-04' },
      { id: 'ch2', title: '第2话 同名之人', updateDate: '2026-08-03' },
      { id: 'ch3', title: '第3话 图书馆邂逅', updateDate: '2026-08-02' },
      { id: 'ch4', title: '第4话 樱花季', updateDate: '2026-08-01' },
    ],
    updateDate: '2026-08-04',
    views: 72100,
    status: '已完结',
    isHot: false,
    isNew: false,
  },
  {
    id: '12',
    title: '时空旅人',
    author: '张瑞元',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20sci-fi%20manhwa%20style%20time%20traveler%20with%20pocket%20watch%20standing%20between%20modern%20and%20historical%20worlds%2C%20surreal%20atmosphere%2C%20clock%20gears%20background%2C%20clean%20composition&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['穿越', '历史', '冒险'],
    rating: 9.5,
    description: '一位历史学家意外获得穿梭时空的能力，在各个时代中寻找改变命运的关键。',
    longDescription: '首尔大学历史系教授郑宇成在研究一件朝鲜时代的古董怀表时，意外触发了时空穿越的能力。他发现自己可以在不同历史时期之间穿梭——三国时代、高丽王朝、朝鲜时代...每到一个时代，他都会卷入当时的重大历史事件中。然而他渐渐意识到，自己的每一次穿越都在对时间线产生微妙的影响，而这些改变的代价可能比他想象的更加沉重。',
    chapters: [
      { id: 'ch1', title: '第1话 古董怀表', updateDate: '2026-08-02' },
      { id: 'ch2', title: '第2话 高丽之行', updateDate: '2026-08-01' },
      { id: 'ch3', title: '第3话 历史的涟漪', updateDate: '2026-07-31' },
      { id: 'ch4', title: '第4话 蝴蝶效应', updateDate: '2026-07-30' },
      { id: 'ch5', title: '第5话 时代守护者', updateDate: '2026-07-29' },
    ],
    updateDate: '2026-08-02',
    views: 138900,
    status: '连载中',
    isHot: true,
    isNew: false,
  },
];